import React, { Component } from 'react';
import { TextField, FlatButton, RaisedButton, IconButton } from 'material-ui';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Box from '../ui/Box';;
import Dialog from 'material-ui/Dialog/Dialog';

//services
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class ServicesCRUDComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            description: '',
            all_services: [],
            temp: {},
            edit: false,
            dialog: {
                open: false,
                head: 'Dude',
                body: 'This is working',
                actions: [
                    <FlatButton
                        label="Okay"
                        primary
                        onClick={this.closeDialog.bind(this)}
                    />
                ]
            }
        }
    }
    componentDidMount() {
        this.getAllServices();
    }
    handleChanges(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handleChanges_edit(field, e) {
        let temp = this.state.temp;
        temp[field] = e.target.value
        this.setState({
            temp: temp
        }, () => {
            console.log(this.state)
        });
    }
    closeDialog() {
        this.setState({
            dialog: {
                head: '',
                body: '',
                open: false,
                actions: []
            }
        })

    }
    getAllServices() {
        ds.getAllButtonServices(data => {
            this.setState({
                all_services: data.docs
            })
            // if (data && data.docs && data.docs.length) {
            //     this.setState({
            //         all_services: data.docs
            //     })
            // }
            // else if (data && data.docs && !data.docs.length) {
            //     this.setState({
            //         all_services: []
            //     })
            // }
        }, err => {

        })
    }
    createService(e) {
        e.preventDefault();
        if (this.validated()) {
            if (this.state.edit == true) {
                ds.postEditButtonService({
                    _id: this.state.temp._id,
                    name: this.state.name,
                    description: this.state.description
                }, data => {
                    this.setState({
                        dialog: {
                            open: true,
                            head: 'Success',
                            body: 'Service Edits Saved',
                            actions: [
                                <FlatButton
                                    label="Okay"
                                    primary
                                    onClick={this.closeDialog.bind(this)}
                                />
                            ]
                        },
                        name: "",
                        description: "",
                        edit: false
                    })
                    this.getAllServices();
                }, err => { })
            }
            else {
                ds.postCreateButtonService({
                    name: this.state.name,
                    description: this.state.description
                }, data => {
                    this.setState({
                        name: "",
                        description: "",
                        all_services: [...this.state.all_services, data]
                    })
                }, err => { })
            }
        }
    }
    validated() {
        let _validated = true;
        if (!this.state.name) {
            this.setState({
                dialog: {
                    open: true,
                    head: 'Invalid',
                    body: 'Name is required',
                    actions: [
                        <FlatButton
                            label="Okay"
                            primary
                            onClick={this.closeDialog.bind(this)}
                        />
                    ]
                }
            })
            _validated = false;
        }
        return _validated;
    }
    deleteService(row) {
        this.setState({
            dialog: {
                open: true,
                head: 'Delete?',
                body: 'Delete Service permanently?',
                actions: [
                    <FlatButton
                        label="Delete"
                        primary
                        onClick={() => {
                            ds.postDeleteButtonService({ _id: row._id },
                                data => {
                                    let x = this.state.current_offset - this.state.maxItems;
                                    this.closeDialog();
                                    this.getAllServices();
                                }, err => {
                                    console.log(err);
                                });
                        }}
                    />,
                    <FlatButton
                        label="Cancel"
                        primary
                        onClick={this.closeDialog.bind(this)}
                    />
                ]
            }
        })
    }
    editService(row, ind) {
        this.setState({
            edit: true,
            temp: { ...row },
            name: row.name,
            description: row.description
        })
    }

    render() {
        let { all_services } = this.state;
        return (
            <div>



                {all_services && all_services.length ? <div className="col-sm-6">
                    <Box header='Services List'>
                        <Table
                            height={'350px'}
                            fixedHeader={true}
                            fixedFooter={true}
                            selectable={false}
                            multiSelectable={false}
                        >
                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                <TableRow>
                                    <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
                                    <TableHeaderColumn tooltip="Description">Description</TableHeaderColumn>
                                    <TableHeaderColumn tooltip="Options" className="align-center">Options</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody
                                displayRowCheckbox={false}
                                showRowHover={true}
                                stripedRows={false}
                            >
                                {all_services.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableRowColumn>{row.name}</TableRowColumn>
                                        <TableRowColumn>{row.description}</TableRowColumn>
                                        <TableRowColumn>
                                            <IconButton onClick={this.editService.bind(this, row, index)}>
                                                <i className="material-icons link-fg">mode_edit</i>
                                            </IconButton>
                                            <IconButton onClick={this.deleteService.bind(this, row)}>
                                                <i className="material-icons warn-fg">delete</i>
                                            </IconButton>
                                        </TableRowColumn>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </div> : null}


                <div className="col-sm-6">
                    <Box header={`${this.state.edit ? 'Edit' : 'Create a'} Service`}>
                        <div>
                            <Dialog
                                title={this.state.dialog.head}
                                actions={this.state.dialog.actions}
                                modal={false}
                                open={this.state.dialog.open}
                                onRequestClose={this.closeDialog.bind(this)}
                            >
                                {this.state.dialog.body || ""}
                            </Dialog>
                            <form onSubmit={this.createService.bind(this)}>
                                <div className="col-sm-12 p-0">
                                    <h5>{`${this.state.edit ? 'Edit' : 'Create a new'}`} Service</h5>
                                </div>
                                <div>
                                    <section>
                                        <TextField
                                            floatingLabelText="Service Name"
                                            name="name"
                                            className="w-100"
                                            value={this.state.name}
                                            onChange={this.handleChanges.bind(this)}
                                        />
                                    </section>
                                    <section>
                                        <TextField
                                            floatingLabelText="Service Description (optional)"
                                            name="description"
                                            className="w-100"
                                            value={this.state.description}
                                            onChange={this.handleChanges.bind(this)}
                                        />
                                    </section>
                                </div>
                                <div className="mt-4vw align-right">
                                    <RaisedButton
                                        label="Save"
                                        primary
                                        type="submit"
                                        className="mr-1vw"
                                    />
                                    {this.state.edit ?
                                        <FlatButton
                                            label="Cancel"
                                            primary
                                            type="button"
                                            onClick={() => {
                                                this.setState({
                                                    edit: false,
                                                    temp: {},
                                                    name: "",
                                                    description: ""
                                                })
                                            }}
                                        /> : null}
                                </div>
                            </form>
                        </div>
                    </Box>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/services/ServicesCRUDComponent.js